import './App.css';
import About from './About'
import Skills from './Skills'
import Projects from './Projects'
import Contact from './Contact'
import Navbar from './Navbar';
import Home from './Home';

function App() {
  return (
    <>
    <Navbar/>
    <Home/>
    <About/>
    <Skills/>
    <Projects/>
    <Contact/>
    </>


  )
}

export default App;
